import React, { Component } from "react";
import { Editor, EditorState, convertToRaw, convertFromRaw, RichUtils } from "draft-js";
import 'draft-js/dist/Draft.css';
import { compose } from "redux";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { updateEvaluationB } from "../../../../stores/actions/evaluationBAction";


//display question
class DisplayQuestionnaireDetails extends Component {
    constructor(props) {
        super(props);
        this.selectRef = React.createRef();
        this.state = {
            selectedQuestion: null,


            //temporary state to store Answer data
            getAnswerContent: '',
            getAnswerMark: null,
            getAnswerStatus: null,
            getAnswerReview: EditorState.createEmpty(),
            getAnswerRef: '',
            isLoading: null,

            hasDescription: false,
        }
        this.baseState = this.state
    }

    loadSelectedQuestion = () => {
        const { questionData, selectedQuestionId } = this.props;

        if (!questionData || !Array.isArray(questionData) || !selectedQuestionId) {
            this.setState({
                selectedQuestion: null
            });
            return
        }

        const selectedQuestion = questionData.find(question => question.id === selectedQuestionId);


        if (selectedQuestion) {

            //Convert descriptions to EditorState from raw content
            let processedQuestion = { ...selectedQuestion };

            if (processedQuestion.descriptions && Object.keys(processedQuestion.descriptions).length > 0) {
                try {
                    const editorState = EditorState.createWithContent(
                        convertFromRaw(processedQuestion.descriptions)
                    );
                    processedQuestion.descriptions = editorState;

                    // Check if editor has any text content
                    const hasText = editorState.getCurrentContent().hasText();

                    this.setState({
                        hasDescription: hasText
                    });
                } catch (error) {
                    processedQuestion.descriptions = EditorState.createEmpty();
                    this.setState({
                        hasDescription: false
                    });
                }
            } else {
                //create empty EditorState for empty descriptions !! = KIV dulu
                processedQuestion.descriptions = EditorState.createEmpty();
                this.setState({
                    hasDescription: false
                })
            }

            this.setState({
                selectedQuestion: processedQuestion
            });
        } else {
            this.setState({
                selectedQuestion: null,
            })
        }
    }


    componentDidMount() {
        if (this.props.onMountRegister) {
            this.props.onMountRegister(this.resetState);
        }
        this.loadSelectedQuestion();

    }

    componentDidUpdate(prevProps, prevState) {

        const { updateEvaluationBSuccess, updateEvaluationBError } = this.props;


        if (prevProps.updateEvaluationBError !== updateEvaluationBError) {
            window.alert('Question Update Failed');
            this.setState({
                isLoading: false,
                message: {
                    msg: updateEvaluationBError.message,
                    type: updateEvaluationBError.type
                }
            })
        }

        if (prevProps.updateEvaluationBSuccess !== updateEvaluationBSuccess) {
            window.alert('Question Updated Successfully');
            this.setState({
                isLoading: false,
                message: {
                    msg: updateEvaluationBSuccess.message,
                    type: updateEvaluationBSuccess.type
                }
            })
            setTimeout(() => {
                const currentSchemes = this.state.schemes;
                this.setState({ ...this.baseState, schemes: currentSchemes })
                this.props.hideModal_questionDetails();
            }, 500)
        }


        if (prevProps.selectedQuestionId !== this.props.selectedQuestionId || prevProps.questionData !== this.props.questionData) {
            const modalContent = document.querySelector('.mymodal-content');
            if (modalContent) {
                modalContent.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
            }
            this.loadSelectedQuestion();
        }

        if (prevProps.schemes !== this.props.schemes) {
            this.setState({
                schemes: [...this.props.schemes]
            })
        }
    }

    isFormInvalid = () => {
        const { getAnswerContent, getAnswerMark, getAnswerRef, getAnswerReview, getAnswerStatus } = this.state;

        const reviewText = getAnswerReview.getCurrentContent().getPlainText();

        return (
            !getAnswerContent.trim() || //also check for whitespace-only strings
            getAnswerMark === null ||
            getAnswerStatus === null ||
            !reviewText.trim() ||
            !getAnswerRef.trim()
        );
    }

    handleDescriptionToggle = () => {
        this.setState(prevState => {
            const newHasDescription = !prevState.hasDescription;

            return {
                hasDescription: newHasDescription,
                selectedQuestion: {
                    ...prevState.selectedQuestion,
                    descriptions: !newHasDescription ? EditorState.createEmpty() : prevState.selectedQuestion.descriptions
                }
            };
        });
    }

    handleDescriptionChange = (newEditorState) => {

        this.setState(prevState => ({
            selectedQuestion: {
                ...prevState.selectedQuestion,
                descriptions: newEditorState
            }
        }))
    }

    _onBoldClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'BOLD'));
    }

    _onItalicClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'ITALIC'));
    }

    _onUnderlineClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'));
    }

    handleKeyCommand = (command, editorState, changeHandler) => {
        const newState = RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            changeHandler(newState);
            return 'handled';
        }
        return 'not-handled';
    }


    handleCriteriaChange = (e) => {
        const selectedId = e.target.value;
        const { criteria } = this.props;

        if (selectedId) {
            const foundCriteria = criteria.find(c => c.id === selectedId);
            this.setState(prevState => ({
                selectedQuestion: {
                    ...prevState.selectedQuestion,
                    selectedCriteria: foundCriteria
                }
            }));
        }
    }

    handleQuestionChange = (e) => {
        this.setState(prevState => ({
            selectedQuestion: {
                ...prevState.selectedQuestion,
                question: e.target.value
            }
        }))
    }

    handleSchemeSelection = (e) => {
        const { schemes } = this.props;
        const selectedSchemeId = e.target.value;

        if (!selectedSchemeId) return;

        const selectedScheme = schemes.find(scheme => scheme.id === selectedSchemeId);

        if (!selectedScheme) return;

        const schemeSubset = {
            id: selectedScheme.id,
            name: selectedScheme.name,
            code: selectedScheme.code
        }
        this.setState(prevState => ({
            selectedQuestion: {
                ...prevState.selectedQuestion,//spread all of previously unaffected selectedQuestion
                selectedSchemes: [...(prevState.selectedQuestion.selectedSchemes || []), schemeSubset]//only this key is affected. spread also the previous data and then comma followed with updated data
            }
        }), () => {
            this.selectRef.current.value = "";
        });
    }

    handleSelectedSchemeDelete = (schemeId) => {
        this.setState(prevState => {
            const remainingSchemes = prevState.selectedQuestion.selectedSchemes.filter(
                scheme => scheme.id !== schemeId
            );

            return {
                selectedQuestion: {
                    ...prevState.selectedQuestion,
                    selectedSchemes: remainingSchemes
                }
            }
        });
    }

    renderRichText = (rawContent) => {
        try {
            const contentState = convertFromRaw(rawContent);
            const editorState = EditorState.createWithContent(contentState);

            return (
                <div style={{ border: '1px solid #ddd', padding: '8px', backgroundColor: '#f9f9f9', minHeight: '30px' }}>
                    <Editor editorState={editorState} readOnly={true} onChange={() => { }} />
                </div>
            )

        } catch (error) {
            return <span style={{ cursor: 'default' }}>
                {JSON.stringify(rawContent)}
            </span>
        }
    }

    removeAnswer = (event, index) => {
        const { selectedQuestion } = this.state;
        let removedAnswer = selectedQuestion.answers.filter((ans, filteredIndex) => {

            return filteredIndex !== index
        });
        this.setState(prevState => {
            return {
                selectedQuestion: {
                    ...prevState.selectedQuestion,
                    answers: removedAnswer
                }
            }
        })
    }

    onReviewChange = getAnswerReview => {
        this.setState({
            getAnswerReview
        });
    }

    saveAnswer = () => {
        const { getAnswerContent, getAnswerMark, getAnswerReview, getAnswerStatus, getAnswerRef } = this.state;

        const reviewRawContent = convertToRaw(getAnswerReview.getCurrentContent());

        this.setState(prevState => {
            return {
                selectedQuestion: {
                    ...prevState.selectedQuestion,
                    answers: [
                        ...prevState.selectedQuestion.answers, {
                            text: getAnswerContent,
                            score: isNaN(parseInt(getAnswerMark)) ? null : parseInt(getAnswerMark),
                            status: getAnswerStatus,
                            review: reviewRawContent,
                            reference: getAnswerRef
                        }],

                },
                getAnswerContent: '',
                getAnswerMark: null,
                getAnswerReview: EditorState.createEmpty(),
                getAnswerStatus: null,
                getAnswerRef: ''
            }
        })
    }

    updateQuestion = () => {
        const { profile } = this.props
        const { selectedQuestion } = this.state;

        const {
            answers,
            createdBy,
            createdDate,
            descriptions,
            question,
            selectedCriteria,
            selectedSchemes,
            id
        } = selectedQuestion;

        const updatedEvaluationB = {
            answers,
            createdBy,
            createdDate,
            descriptions: descriptions ? convertToRaw(selectedQuestion.descriptions.getCurrentContent()) : null,
            question,
            selectedCriteria,
            selectedSchemes
        }

        var update = window.confirm("Confirm Update?");
        if (update) {
            const date = new Date();
            const createdAt = date.toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                timeZone: 'Asia/Singapore'
            }) + ' at ' + date.toLocaleTimeString('en-GB', {
                hour12: false,
                timeZone: 'Asia/Singapore'
            }) + ' UTC+8';

            this.setState(prevState => {
                return {
                    selectedQuestion: {
                        ...prevState.selectedQuestion,
                        createdDate: createdAt,
                        createdBy: profile.userId
                    }
                }
            }, () => {
                this.props.updateEvaluationB(updatedEvaluationB, id)
            })
        }
    }

    resetState = () => {//reset all state bila 'X' is clicked
        this.setState({
            getAnswerContent: '',
            getAnswerMark: null,
            getAnswerStatus: null,
            getAnswerReview: EditorState.createEmpty(),
            getAnswerRef: '',
        })
    }

    render() {
        const { selectedQuestion, hasDescription, } = this.state;
        const { questionData, criteria, schemes } = this.props;

        if (!selectedQuestion) {
            return <div>Please select a question first</div>
        }

        const filteredScheme = schemes ? schemes.filter(scheme =>
            !selectedQuestion.selectedSchemes.some(selected => selected.id === scheme.id)
        ) : [];


        if (!questionData || !Array.isArray(questionData)) {
            return <div>
                Loading question data...
            </div>
        }

        console.log(this.state);
        return (

            <div>

                {selectedQuestion ? (
                    <div>
                        <div className="uppercase middle"><span> Editing <b>{selectedQuestion.question}</b> Info</span>
                            <div className="title-border"></div>
                        </div>
                        <p>
                            <b>Question:</b>
                            <input type="text" className="col-md-12 form-control" placeholder="Question" value={selectedQuestion.question} onChange={this.handleQuestionChange} />
                            <input type="checkbox" checked={hasDescription} onChange={this.handleDescriptionToggle} /> Descriptions
                        </p>
                        {hasDescription ? (
                            <div style={{ backgroundColor: '#eeeeee', padding: '10px' }}>
                                <div className="col-md d-flex align-items-center justify-content-start" style={{ marginBottom: '10px', paddingBottom: '5px' }}>
                                    <button
                                        type="button"
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => this._onBoldClick(selectedQuestion.descriptions, this.handleDescriptionChange)}
                                        style={{
                                            fontWeight: selectedQuestion.descriptions.getCurrentInlineStyle().has('BOLD') ? 'bold' : 'normal',
                                            marginRight: '5px',
                                            padding: '5px 10px',
                                            border: '1px solid #ccc',
                                            backgroundColor: selectedQuestion.descriptions.getCurrentInlineStyle().has('BOLD') ? '#e6f3ff' : 'white',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <strong>B</strong>
                                    </button>
                                    <button
                                        type="button"
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => this._onItalicClick(selectedQuestion.descriptions, this.handleDescriptionChange)}
                                        style={{
                                            fontStyle: selectedQuestion.descriptions.getCurrentInlineStyle().has('ITALIC') ? 'italic' : 'normal',
                                            marginRight: '5px',
                                            padding: '5px 10px',
                                            border: '1px solid #ccc',
                                            backgroundColor: selectedQuestion.descriptions.getCurrentInlineStyle().has('ITALIC') ? '#e6f3ff' : 'white',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <em>I</em>
                                    </button>
                                    <button
                                        type="button"
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => this._onUnderlineClick(this.state.selectedQuestion.descriptions, this.handleDescriptionChange)}
                                        style={{
                                            textDecoration: selectedQuestion.descriptions.getCurrentInlineStyle().has('UNDERLINE') ? 'underline' : 'normal',
                                            marginRight: '5px',
                                            padding: '5px 10px',
                                            border: '1px solid #ccc',
                                            backgroundColor: selectedQuestion.descriptions.getCurrentInlineStyle().has('UNDERLINE') ? '#e6f3ff' : 'white',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <u>U</u>
                                    </button>
                                </div>
                                <div style={{ border: '1px solid #ccc', minHeight: '50px', padding: '10px', flexGrow: 1, backgroundColor: 'white' }}>
                                    <Editor
                                        editorState={selectedQuestion.descriptions}
                                        onChange={this.handleDescriptionChange}
                                        handleKeyCommand={(command) => this.handleKeyCommand(command, selectedQuestion.descriptions, this.handleDescriptionChange)}
                                        placeholder="Description" />
                                </div>
                            </div>
                        ) : ('')}
                        <div>
                            <b>Criteria: </b>
                            <select className="form-control" value={selectedQuestion.selectedCriteria?.id || ""} onChange={this.handleCriteriaChange}>
                                <option value="">Choose Criteria</option>
                                {criteria && criteria.map((c, i) => (
                                    <option key={i} value={c.id}>
                                        {c.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div style={{ paddingBottom: '15px' }}>
                            <b>Related Schemes:</b>
                            <select ref={this.selectRef} className="form-control" onChange={this.handleSchemeSelection}>
                                <option value="">Choose Related Scheme&#40;s&#41;</option>
                                {filteredScheme.map((scheme, index) => (
                                    <option key={scheme.id} value={scheme.id}>
                                        {scheme.name} &#40;{scheme.code}&#41;
                                    </option>
                                ))
                                }
                            </select>
                            <b>Selected Schemes</b>
                            {selectedQuestion.selectedSchemes && selectedQuestion.selectedSchemes.map((selectedScheme, index) => (
                                <div key={selectedScheme.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ position: 'relative', left: '20px' }}>{selectedScheme.name} &#40;{selectedScheme.code}&#41;</div>
                                    <span onClick={() => this.handleSelectedSchemeDelete(selectedScheme.id)}><i className="fa fa-trash text-red"></i></span>
                                </div>
                            ))}
                        </div>
                        <div style={{ backgroundColor: '#eeeeee', padding: '10px' }}>
                            <div>
                                <b>Answer:</b>
                                <input type="text" className="form-control" value={this.state.getAnswerContent || ''} onChange={event => this.setState({ getAnswerContent: event.target.value })} placeholder="Answer" />
                            </div>
                            <div>
                                <b>Status:</b>
                                <select className="form-control" value={this.state.getAnswerStatus || ''} onChange={event => this.setState({ getAnswerStatus: event.target.value })}>
                                    <option defaultValue>Choose Answer Status</option>
                                    <option value={'Keperluan Belum Dipenuhi'}>Keperluan Belum Dipenuhi</option>
                                    <option value={'Keperluan Belum Sepenuhnya Lengkap'}>Keperluan Belum Sepenuhnya Lengkap</option>
                                    <option value={'Keperluan Telah Dipenuhi'}>Keperluan Telah Dipenuhi</option>
                                </select>
                            </div>
                            <div>
                                <b>Mark:</b>
                                <select className="col-md-5 form-control" value={this.state.getAnswerMark || ''} onChange={event => this.setState({ getAnswerMark: event.target.value })}>
                                    <option defaultValue>Choose Mark Value</option>
                                    <option value={0}>0 - Tiada</option>
                                    <option value={1}>1 - Ada &#40;Tidak Lengkap&#41;</option>
                                    <option value={2}>2 - Ada &#40;Separa Lengkap&#41;</option>
                                    <option value={3}>3 - Ada &#40;Lengkap&#41;</option>
                                </select>
                            </div>
                            <div>
                                <b>Answer Review</b>
                                <div style={{ marginBottom: '10px', paddingBottom: '5px' }}>
                                    <button
                                        type="button"
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => this._onBoldClick(this.state.getAnswerReview, this.onReviewChange)}
                                        style={{
                                            fontWeight: this.state.getAnswerReview.getCurrentInlineStyle().has('BOLD') ? 'bold' : 'normal',
                                            marginRight: '5px',
                                            padding: '5px 10px',
                                            border: '1px solid #ccc',
                                            backgroundColor: this.state.getAnswerReview.getCurrentInlineStyle().has('BOLD') ? '#e6f3ff' : 'white',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <strong>B</strong>
                                    </button>
                                    <button
                                        type="button"
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => this._onItalicClick(this.state.getAnswerReview, this.onReviewChange)}
                                        style={{
                                            fontStyle: this.state.getAnswerReview.getCurrentInlineStyle().has('ITALIC') ? 'italic' : 'normal',
                                            marginRight: '5px',
                                            padding: '5px 10px',
                                            border: '1px solid #ccc',
                                            backgroundColor: this.state.getAnswerReview.getCurrentInlineStyle().has('ITALIC') ? '#e6f3ff' : 'white',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <em>I</em>
                                    </button>
                                    <button
                                        type="button"
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => this._onUnderlineClick(this.state.getAnswerReview, this.onReviewChange)}
                                        style={{
                                            textDecoration: this.state.getAnswerReview.getCurrentInlineStyle().has('UNDERLINE') ? 'underline' : 'normal',
                                            marginRight: '5px',
                                            padding: '5px 10px',
                                            border: '1px solid #ccc',
                                            backgroundColor: this.state.getAnswerReview.getCurrentInlineStyle().has('UNDERLINE') ? '#e6f3ff' : 'white',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <u>U</u>
                                    </button>
                                </div>
                                <div style={{ border: '1px solid #ccc', minHeight: '100px', padding: '10px', backgroundColor: 'white' }}>
                                    <Editor
                                        editorState={this.state.getAnswerReview}
                                        onChange={this.onReviewChange}
                                        handleKeyCommand={(command) => this.handleKeyCommand(command, this.state.getAnswerReview, this.onReviewChange)}
                                        placeholder="Review"></Editor>
                                </div>

                            </div>
                            <div>
                                <b>Answer Reference:</b>
                                <textarea className="form-control" value={this.state.getAnswerRef || ''} onChange={event => this.setState({ getAnswerRef: event.target.value })} placeholder="Reference"></textarea>
                            </div>
                            <button style={{ border: 'none' }} disabled={this.isFormInvalid()} className={this.isFormInvalid() ? "badge bg-lightBlue text-white" : "badge bg-blue text-white"} onClick={this.saveAnswer.bind(this)}>Save and Add New Answer</button>
                            <div>
                                <b className="mb-3">Answer Preview</b>
                                {selectedQuestion.answers && selectedQuestion.answers.map((answer, index) => {
                                    return (
                                        <div style={{ marginLeft: '30px', }} key={index} className="mb-1 listing d-flex mt-3 ml-2 pl-4 pt-2">
                                            <div className="list-icon" style={{ top: '15px' }}><span onClick={(event) => this.removeAnswer(event, index)}><i className="fas fa-trash text-red"></i></span></div>
                                            <div className="d-flex flex-column">
                                                <label>Answer: {answer.text}</label>
                                                <label>Score: {answer.score}</label>
                                                <label>Status: {answer.status}</label>
                                                <label>Review: {this.renderRichText(answer.review)}</label>
                                                <label>Reference: <b>{answer.reference}</b></label>
                                            </div>

                                        </div>
                                    )

                                })}
                            </div>
                        </div>
                        <div className="mt-5 row justify-content-end">
                            <button className="btn m-2 btn-outline-black" onClick={this.updateQuestion.bind(this)}><i className="fas fa-edit" />{' '}Update Question</button>
                        </div>
                    </div>
                ) : (
                    <div>No data available</div>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {

        updateEvaluationBSuccess: state.evaluationB.updateEvaluationBSuccess,
        updateEvaluationBError: state.evaluationB.updateEvaluationBError
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateEvaluationB: (updatedEvaluationB, evaluationBId) => dispatch(updateEvaluationB(updatedEvaluationB, evaluationBId))
    }
}


export default compose(
    connect(mapStateToProps, mapDispatchToProps),

)(DisplayQuestionnaireDetails);